import { PagesModule } from './pages/pages.module';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MatProgressSpinnerModule, MatButtonModule } from '@angular/material';
import { MatDialogModule } from '@angular/material';
import { StarRatingModule } from 'angular-star-rating';

import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressRouterModule } from '@ngx-progressbar/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { LoginComponent } from './pages/login/login.component';
import { RouteGuardService } from './route-guard.service';
import { LoginService } from './login.service';
import { ApiBasic } from './services/api-basic';
import { FeedbackModule } from './feedback/feedback.module';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { MatIconModule } from '@angular/material';
import { PlatformModule } from '@angular/cdk/platform';
// import { RatingModule } from 'ng-starrating';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PrivacyComponent

  ],
  imports: [
    BrowserModule,
    FeedbackModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ComponentsModule,
    NgbModule.forRoot(),
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    NgProgressModule.forRoot(),
    NgProgressRouterModule,
    FormsModule, ReactiveFormsModule,
    StarRatingModule.forRoot(),
    HttpClientModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    MatIconModule,
    MatButtonModule,
    PagesModule,
    PlatformModule
  ],
  providers: [RouteGuardService, LoginService, ApiBasic],
  bootstrap: [AppComponent]
})
export class AppModule { }
